<script setup>
import { ref } from "vue";
import CrowdfundingLiveOrganism from "/src/components/organisms/CrowdfundingLiveOrganism.vue";
import { stripe } from "/src/stripe.js";
import { useRoute } from "vue-router";
import db from "../main.js";
import {
  doc,
  setDoc,
  query,
  collection,
  getDocs,
  orderBy,
  limit,
  getDoc,
  where,
  Timestamp,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

const props = defineProps({
  user: Object,
});

const showmessage = ref([]);
const showranking = ref();

const route = useRoute();
// クラウドファンディングの場合はcampaignIdからevent_idを取得
const event_id = ref(route.params.campaignId);
const live_id = ref(route.query.live_id);
const isLoadingforcredit = ref(true);

//videoのURL用とライブ開始時間を取得
const sendmessage = ref("testsendmessage");
const videourl = ref(null);
const videourlforondemand = ref(null);
const livestarttime = ref(null);
const livestartimejs = ref(null);
const MessageTime = ref(null);

const getvideurl = async () => {
  // live_idが指定されている場合は、Crowdfunding_livesheduleから取得
  if (live_id.value) {
    try {
      const liveDocRef = doc(db, "Crowdfunding_liveshedule", live_id.value);
      const liveDocSnap = await getDoc(liveDocRef);

      if (liveDocSnap.exists()) {
        const liveData = liveDocSnap.data();

        // アーカイブ動画URLを取得
        if (liveData.archive_videourl) {
          videourl.value = liveData.archive_videourl;
        }

        // オンデマンド動画URLを取得
        if (liveData.videouid) {
          videourlforondemand.value =
            process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN +
            liveData.videouid +
            "/manifest/video.m3u8?protocol=llhls";

          console.log("videouid:", liveData.videouid);
          console.log("videourlforondemand:", videourlforondemand.value);

          // archive_videourlがない場合は、videouidから生成したURLをvideourlに設定
          if (!videourl.value) {
            videourl.value = videourlforondemand.value;
            console.log("videourlにvideourlforondemandを設定:", videourl.value);
          }
        }

        console.log("最終的なvideourl:", videourl.value);

        // ライブ開始時刻を取得
        if (liveData.livedate?.start) {
          livestarttime.value = liveData.livedate.start;
          livestartimejs.value = livestarttime.value.toDate();

          console.log("livestarttime: " + livestarttime.value);
          console.log("livestartimejs: " + livestartimejs.value);

          // Timestampオブジェクトに変換
          MessageTime.value = Timestamp.fromDate(livestartimejs.value);

          // ライブ開始時刻以降のメッセージを取得
          const q = query(
            collection(db, "Crowdfunding_automessages", event_id.value, "automessages"),
            orderBy("created_at", "asc"),
            where("created_at", ">=", MessageTime.value)
          );

          // 一度だけクエリを実行（アーカイブなのでリアルタイム更新は不要）
          getDocs(q)
            .then((querySnapshot) => {
              const nameshot = [];
              querySnapshot.forEach((doc) => {
                const setmessage = doc.data();
                showmessage.value.push(setmessage);
              });
              console.log(nameshot);
              console.log(showmessage.value);
            })
            .catch((error) => {
              console.error("Error getting documents: ", error);
            });
        }
        return;
      }
    } catch (error) {
      console.error("ライブスケジュール取得エラー:", error);
    }
  }

  // live_idが指定されていない場合、projectidでCrowdfunding_livesheduleをクエリ
  // 同じprojectidでも複数のライブスケジュールが存在する可能性があるため
  try {
    const livesQuery = query(
      collection(db, "Crowdfunding_liveshedule"),
      where("projectid", "==", event_id.value),
      orderBy("livedate.start", "desc"), // 最新の配信を取得
      limit(1)
    );

    const livesSnapshot = await getDocs(livesQuery);

    if (!livesSnapshot.empty) {
      const liveData = livesSnapshot.docs[0].data();

      // アーカイブ動画URLを取得
      if (liveData.archive_videourl) {
        videourl.value = liveData.archive_videourl;
      }

      // オンデマンド動画URLを取得
      if (liveData.videouid) {
        videourlforondemand.value =
          process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN +
          liveData.videouid +
          "/manifest/video.m3u8?protocol=llhls";

        // archive_videourlがない場合は、videouidから生成したURLをvideourlに設定
        if (!videourl.value) {
          videourl.value = videourlforondemand.value;
        }
      }

      // ライブ開始時刻を取得
      if (liveData.livedate?.start) {
        livestarttime.value = liveData.livedate.start;
        livestartimejs.value = livestarttime.value.toDate();

        console.log("livestarttime: " + livestarttime.value);
        console.log("livestartimejs: " + livestartimejs.value);

        // Timestampオブジェクトに変換
        MessageTime.value = Timestamp.fromDate(livestartimejs.value);

        // ライブ開始時刻以降のメッセージを取得
        const q = query(
          collection(db, "Crowdfunding_automessages", event_id.value, "automessages"),
          orderBy("created_at", "asc"),
          where("created_at", ">=", MessageTime.value)
        );

        // 一度だけクエリを実行（アーカイブなのでリアルタイム更新は不要）
        getDocs(q)
          .then((querySnapshot) => {
            const nameshot = [];
            querySnapshot.forEach((doc) => {
              const setmessage = doc.data();
              showmessage.value.push(setmessage);
            });
            console.log(nameshot);
            console.log(showmessage.value);
          })
          .catch((error) => {
            console.error("Error getting documents: ", error);
          });
      }
      return;
    }
  } catch (error) {
    console.error("ライブスケジュールクエリエラー:", error);
    // livedate.startでソートできない場合は、projectidのみでクエリして手動でソート
    try {
      const livesQuery = query(
        collection(db, "Crowdfunding_liveshedule"),
        where("projectid", "==", event_id.value)
      );

      const livesSnapshot = await getDocs(livesQuery);

      if (!livesSnapshot.empty) {
        // livedate.startで手動ソート
        const sortedLives = livesSnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((live) => live.livedate?.start)
          .sort((a, b) => {
            const aTime = a.livedate.start.toMillis?.() || 0;
            const bTime = b.livedate.start.toMillis?.() || 0;
            return bTime - aTime; // 降順（最新が先頭）
          });

        if (sortedLives.length > 0) {
          const liveData = sortedLives[0];

          // アーカイブ動画URLを取得
          if (liveData.archive_videourl) {
            videourl.value = liveData.archive_videourl;
          }

          // オンデマンド動画URLを取得
          if (liveData.videouid) {
            videourlforondemand.value =
              process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN +
              liveData.videouid +
              "/manifest/video.m3u8?protocol=llhls";

            // archive_videourlがない場合は、videouidから生成したURLをvideourlに設定
            if (!videourl.value) {
              videourl.value = videourlforondemand.value;
            }
          }

          // ライブ開始時刻を取得
          if (liveData.livedate?.start) {
            livestarttime.value = liveData.livedate.start;
            livestartimejs.value = livestarttime.value.toDate();

            console.log("livestarttime: " + livestarttime.value);
            console.log("livestartimejs: " + livestartimejs.value);

            // Timestampオブジェクトに変換
            MessageTime.value = Timestamp.fromDate(livestartimejs.value);

            // ライブ開始時刻以降のメッセージを取得
            const q = query(
              collection(db, "Crowdfunding_automessages", event_id.value, "automessages"),
              orderBy("created_at", "asc"),
              where("created_at", ">=", MessageTime.value)
            );

            // 一度だけクエリを実行（アーカイブなのでリアルタイム更新は不要）
            getDocs(q)
              .then((querySnapshot) => {
                const nameshot = [];
                querySnapshot.forEach((doc) => {
                  const setmessage = doc.data();
                  showmessage.value.push(setmessage);
                });
                console.log(nameshot);
                console.log(showmessage.value);
              })
              .catch((error) => {
                console.error("Error getting documents: ", error);
              });
          }
          return;
        }
      }
    } catch (fallbackError) {
      console.error("ライブスケジュールフォールバック取得エラー:", fallbackError);
    }
  }

  // ライブスケジュールが見つからない場合、プロジェクトデータから取得（フォールバック）
  const docRef = doc(db, "Crowdfunding_projects", event_id.value);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data();

    // アーカイブ動画URLを取得
    if (data.archive_videourl) {
      videourl.value = data.archive_videourl;
    }

    // オンデマンド動画URLを取得
    if (data.videouid) {
      videourlforondemand.value =
        process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN +
        data.videouid +
        "/manifest/video.m3u8?protocol=llhls";

      // archive_videourlがない場合は、videouidから生成したURLをvideourlに設定
      if (!videourl.value) {
        videourl.value = videourlforondemand.value;
      }
    }

    // ライブ開始時刻を取得
    if (data.livedate?.start) {
      livestarttime.value = data.livedate.start;
      livestartimejs.value = livestarttime.value.toDate();

      console.log("livestarttime: " + livestarttime.value);
      console.log("livestartimejs: " + livestartimejs.value);

      // Timestampオブジェクトに変換
      MessageTime.value = Timestamp.fromDate(livestartimejs.value);

      // ライブ開始時刻以降のメッセージを取得
      const q = query(
        collection(db, "Crowdfunding_automessages", event_id.value, "automessages"),
        orderBy("created_at", "asc"),
        where("created_at", ">=", MessageTime.value)
      );

      // 一度だけクエリを実行（アーカイブなのでリアルタイム更新は不要）
      getDocs(q)
        .then((querySnapshot) => {
          const nameshot = [];
          querySnapshot.forEach((doc) => {
            const setmessage = doc.data();
            showmessage.value.push(setmessage);
          });
          console.log(nameshot);
          console.log(showmessage.value);
        })
        .catch((error) => {
          console.error("Error getting documents: ", error);
        });
    }
  }
};
getvideurl();

//お茶代読み込み（クラウドファンディングにはお茶代がないため、0のまま）
const ochaPrice = ref(0);

const addresses = ref([]);

async function getAddressData() {
  addresses.value = [];
  const querySnapshot = await getDocs(collection(db, "users", props.user.uid, "addresses"));
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    addresses.value.push(data);
  });
}
getAddressData();

//登録済みクレジットカード呼び出し
const cardsInfo = ref(null);
const defaultCard = ref(null);
async function getCreditCard() {
  isLoadingforcredit.value = true;
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const myCallableFunction = httpsCallable(functions, "Common_cardslist");
  myCallableFunction({})
    .then((result) => {
      cardsInfo.value = result.data.cards;
      defaultCard.value = result.data.defaultCardId;

      isLoadingforcredit.value = false;
    })
    .catch((error) => {
      console.log(error.message);
    });
}

const errorfortreca = ref(null);
//トレカ購入（クレジットカード）
const supercommentDone = ref(false);
const comfirmBuy = async (selectitem, choosebuycard, comments, paymentMethodId, trecaid) => {
  console.log("元のコメント" + comments.value);
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  const choosebuycardNo = choosebuycard.value;
  const createPaymentIntent = httpsCallable(functions, "Goods_TrecaCreatePaymentIntent");

  try {
    const result = await createPaymentIntent({
      paymentMethodId: paymentMethodId.value,
      choosebuycard: choosebuycardNo,
    });
    const clientSecret = result.data.clientSecret;
    const paymentIntentId = result.data.paymentIntentId;

    try {
      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId.value,
      });

      if (confirmError) {
        console.error("3Dセキュア認証エラー:", confirmError.message);
        errorfortreca.value = confirmError;
        return;
      }

      if (paymentIntent.status !== "requires_capture") {
        console.error("キャプチャ可能な状態ではありません:", paymentIntent.status);
        error.value = "hapen error";
        errorfortreca.value = "hapen error";
        return;
      }

      const event_idNo = event_id.value;
      const selectitemNo = selectitem.value;
      const trecaidNo = trecaid.value;

      console.log("送信するコメント:", comments.value);
      const captureTrecaPayment = httpsCallable(functions, "Goods_TrecaCapturePayment");
      const result = await captureTrecaPayment({
        choosebuycard: choosebuycardNo,
        paymentIntentId: paymentIntentId,
        paymentMethodId: paymentMethodId.value,
        comments: comments.value,
        event_id: event_idNo,
        orderItems: selectitemNo,
        trecaid: trecaidNo,
      });

      if (result.data.status === "succeeded") {
        console.log(result);
        supercommentDone.value = true;
        getCreditCard();
      } else {
        alert("支払いキャプチャーに失敗しました: " + result.data.status);
        errorfortreca.value = "hapen error";
      }
    } catch (err) {
      console.error("キャプチャー中にエラーが発生しました:", err.message);
      errorfortreca.value = err.message;
    }
  } catch (err) {
    console.error("Error during authorization:", err.message);
    errorfortreca.value = err.message;
  }
};

//トレカ購入（キャリア決裁）
const comfirmBuyforcarrierpayment = (
  selectitem,
  choosebuycard,
  comments,
  chooseaddress,
  cardId,
  trecaid
) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const choosebuycardNo = choosebuycard.value;
  const commentsNo = comments.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;
  const selectitemNo = selectitem.value;
  const trecaidNo = trecaid.value;
  const myCallableFunction = httpsCallable(functions, "Goods_TrecaChargeforcarrierpayment");
  myCallableFunction({
    choosebuycard: choosebuycardNo,
    comments: commentsNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    orderItems: selectitemNo,
    trecaid: trecaidNo,
  })
    .then((result) => {
      window.location.href = decodeURIComponent(result.data.redirectUrl);
    })
    .catch((error) => {
      console.log(error.message);
    });
};

const chooseGoods = async (selectnumber) => {
  if (props.user) {
    await setDoc(
      doc(db, "users", props.user.uid, "Goods_productcartitems", "productcartitems"),
      {
        quantity: selectnumber.value,
        event_id: event_id.value,
        vendorname_ja: vendorname_ja.value,
      },
      {
        merge: false,
      }
    );
  }
};

//トレカの種類を書き込み
const chooseTreca = async () => {
  if (props.user) {
    await setDoc(
      doc(db, "users", props.user.uid, "Goods_supercommentcartitems", "supercommentcartitems"),
      {
        event_id: event_id.value,
        vendorname_ja: vendorname_ja.value,
      },
      {
        merge: false,
      }
    );
  }
};

//paidyでの商品購入（キャプチャー）
const comfirmGoodsforpaidy = (selectnumber, chooseaddress, paidyPaymentId) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const selectnumberNo = selectnumber.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;

  const buyfromlive = false;

  const myCallableFunction = httpsCallable(functions, "Goods_PaidyCharge");

  myCallableFunction({
    selectnumber: selectnumberNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    shippingFee: shippingFee.value,
    buyfromlive: buyfromlive,
    paidyPaymentId: paidyPaymentId,
  })
    .then((result) => {
      orderId.value = paidyPaymentId;
      console.log("Order ID:", result);
    })
    .catch((err) => {
      console.log(err.message);
      error.value = err;
    });
};

const error = ref(null);
//商品のグッズガチャ購入(クレジットカード)
const orderId = ref();
const comfirmGoods = async (selectnumber, choosebuycard, chooseaddress, paymentMethodId) => {
  const functions = getFunctions();
  const createPaymentIntent = httpsCallable(functions, "Goods_CreatePaymentIntent");

  try {
    const result = await createPaymentIntent({
      paymentMethodId,
    });
    const clientSecret = result.data.clientSecret;
    const paymentIntentId = result.data.paymentIntentId;

    try {
      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
      });

      if (confirmError) {
        console.error("3Dセキュア認証エラー:", confirmError.message);
        error.value = confirmError;
        return;
      }

      if (paymentIntent.status !== "requires_capture") {
        console.error("キャプチャ可能な状態ではありません:", paymentIntent.status);
        error.value = "hapen error";
        return;
      }

      const selectnumberNo = selectnumber.value;
      const choosebuycardNo = choosebuycard.value;
      const chooseaddressNo = chooseaddress.value;
      const event_idNo = event_id.value;
      const buyfromlive = false;

      const capturePayment = httpsCallable(functions, "Goods_CapturePayment");
      const result = await capturePayment({
        selectnumber: selectnumberNo,
        choosebuycard: choosebuycardNo,
        chooseaddress: chooseaddressNo,
        event_id: event_idNo,
        paymentIntentId: paymentIntentId,
        shippingFee: shippingFee.value,
        buyfromlive: buyfromlive,
        paymentMethodId: paymentMethodId,
      });

      if (result.data.status === "succeeded") {
        orderId.value = result.data.stripeOrderId;
      } else {
        alert("支払いキャプチャーに失敗しました: " + result.data.status);
        error.value = "hapen error";
      }
    } catch (err) {
      console.error("キャプチャー中にエラーが発生しました:", err.message);
      error.value = err.message;
    }
  } catch (err) {
    console.error("Error during authorization:", err.message);
    error.value = err.message;
  }
};

//通常のコメントをデータベースへ書き込み
const commentinput = async (commenttext) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const campaignId = event_id.value;
  const normalmessageNo = commenttext.value;
  const myCallableFunction = httpsCallable(functions, "Crowdfunding_putnormalcomment");
  myCallableFunction({
    normalmessage: normalmessageNo,
    campaignId: campaignId,
  })
    .then((result) => {
      console.log(result);
    })
    .catch((error) => {
      console.log(error.message);
    });
};

//point呼び出し
const rankingarray = ref([]);
const getpoint = async () => {
  const querypoint = query(
    collection(db, "Goods_ranking", event_id.value, "ranking"),
    limit(3),
    orderBy("points", "desc")
  );

  getDocs(querypoint)
    .then((querySnapshot) => {
      rankingarray.value = [];

      if (querySnapshot.empty) {
        return;
      }

      querySnapshot.forEach((doc) => {
        const setranking = doc.data();
        rankingarray.value.push(setranking);
      });
    })
    .catch((error) => {
      console.error("Error getting ranking: ", error);
    });
};
getpoint();

//vtuberのグッズの商品データを取得
const goodsData = ref([]);
const getProductsData = async () => {
  const querySnapshot = await getDocs(collection(db, "Goods_products", event_id.value, "products"));
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    goodsData.value.push(data);
  });
};

getProductsData();

const sendaddress = async (postcode, address1, address2, name, phoneno) => {
  const postcodeno = postcode.value;
  const address1no = address1.value;
  const address2no = address2.value;
  const nameno = name.value;
  const phonenono = phoneno.value;
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  const addMessage = httpsCallable(functions, "Goods_Addaddress");
  await addMessage({
    postcode: postcodeno,
    address1: address1no,
    address2: address2no,
    name: nameno,
    phoneno: phonenono,
  }).then(async (res) => {
    console.log(res);
    await getAddressData();
  });
};

//表示用の金額と送料
const shippingFee = ref();
const totallPrice = ref();
const quantity = ref();
const sumPrice = ref();

const shippingfeeandorderprice = async () => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  const func = httpsCallable(functions, "Goods_calcOrderPrice_and_shippingFee");

  try {
    const res = await func({ name: "hoge" });
    shippingFee.value = res.data.price_fee.shippingFee;
    totallPrice.value = res.data.price_fee.productPrice + res.data.price_fee.shippingFee;

    const docRef = doc(db, "users", props.user.uid, "Goods_productcartitems", "productcartitems");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      quantity.value = data.quantity;
      sumPrice.value = data.quantity * unitPrice.value;
    } else {
      console.log("No such document!");
    }
  } catch (error) {
    // エラーハンドリング
  }
};

//vendor情報取得及び販売期間中かどうかの判定
const vendorsData = ref();
const vendorname_ja = ref();
const unitPrice = ref();
const isSelling = ref(true);
const suppercommenttype = ref();
const currentAmount = ref(0);
const targetAmount = ref(0);

const vendorData = async () => {
  const docRef = doc(db, "Crowdfunding_projects", event_id.value);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const data = docSnap.data();
    vendorsData.value = {
      ...data,
      eventtitle: data.projectTitle || "",
    };
    vendorname_ja.value = data.vendor_ja || "";
    unitPrice.value = data.targetAmount || 0;
    currentAmount.value = data.currentAmount || 0;
    targetAmount.value = data.targetAmount || 0;
    suppercommenttype.value = null;

    // 販売期間の判定（クラウドファンディングの場合）
    const endTimestamp = data.eventdate?.end;
    if (endTimestamp) {
      const endDate = endTimestamp.toDate();
      const currentDate = new Date();

      if (currentDate > endDate) {
        console.log("販売終了");
        isSelling.value = false;
      }
    }
  }
};
vendorData();

//デフォルトアドレスとデフォルトpaymentmethodの判定
const defaultAddress = ref(false);
const defaultpaymentmethod = ref(null);
const getDefaultAddress = () => {
  getDoc(doc(db, "users", props.user.uid, "sub_accounts", "sub_accounts"))
    .then((docSnap) => {
      if (docSnap.exists()) {
        defaultAddress.value = docSnap.data().default_address;
        defaultpaymentmethod.value = docSnap.data().default_paymentmethod;
      }
    })
    .catch((error) => {
      console.error("Error getting default address: ", error);
    });
};
getDefaultAddress();

//商品のグッズガチャ購入(キャリア決裁)
const comfirmGoodsforcarrierpayment = (selectnumber, choosebuycard, chooseaddress) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  const selectnumberNo = selectnumber.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;
  const myCallableFunction = httpsCallable(functions, "Goods_requestCarrierPaymentforProducts");
  myCallableFunction({
    selectnumber: selectnumberNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    shippingFee: shippingFee.value,
  })
    .then((result) => {
      window.location.href = decodeURIComponent(result.data.redirectUrl);
    })
    .catch((error) => {
      console.log(error.message);
    });
};

//キャリアペイメントのgoodsのダイアログを再び開いて後オーダーIDを追加
orderId.value = String(route.query.orderid || "");
const goods_dialogaftercarrier = ref(false);
const goods_dialogaftercarrierfortreca = ref(false);
if (orderId.value.startsWith("vl")) {
  goods_dialogaftercarrier.value = true;
} else if (orderId.value.startsWith("gt")) {
  goods_dialogaftercarrierfortreca.value = true;
}

// クラウドファンディング用：支援確定処理
const comfirmCrowdfundingSupport = async (supportData) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  try {
    if (supportData.paymentMethod === "creditcard") {
      const createPaymentIntent = httpsCallable(functions, "Crowdfunding_CreatePaymentIntent");

      const result = await createPaymentIntent({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paymentMethodId: supportData.cardId,
        message: supportData.message,
      });

      const clientSecret = result.data.clientSecret;
      const paymentIntentId = result.data.paymentIntentId;

      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: supportData.cardId,
        setup_future_usage: "on_session",
      });

      if (confirmError) {
        console.error("3Dセキュア認証エラー:", confirmError.message);
        error.value = confirmError.message;
        return;
      }

      if (paymentIntent.status !== "requires_capture") {
        console.error("キャプチャ可能な状態ではありません:", paymentIntent.status);
        error.value = "決済処理に失敗しました";
        return;
      }

      const capturePayment = httpsCallable(functions, "Crowdfunding_CapturePayment");
      const captureResult = await capturePayment({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paymentIntentId: paymentIntentId,
        message: supportData.message,
        shippingAddress: supportData.shippingAddress,
      });

      if (captureResult.data.status === "succeeded") {
        orderId.value = captureResult.data.stripeOrderId || captureResult.data.orderId;
        await getCreditCard();
      } else {
        alert("支払いキャプチャーに失敗しました: " + captureResult.data.status);
        error.value = "決済の確定に失敗しました";
      }
    } else if (supportData.paymentMethod === "paidy") {
      const capturePaidy = httpsCallable(functions, "Crowdfunding_PaidyCharge");
      const result = await capturePaidy({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paidyPaymentId: supportData.paidyPaymentId,
        message: supportData.message,
        shippingAddress: supportData.shippingAddress,
      });

      if (result.data.status === "succeeded" || result.data.text === "完了した") {
        orderId.value = supportData.paidyPaymentId;
      } else {
        error.value = "Paidy決済の確定に失敗しました";
      }
    }
  } catch (err) {
    console.error("Error during crowdfunding support:", err.message);
    error.value = err.message;
  }
};

const changecupercommentDone = () => {
  console.log("変更");
  supercommentDone.value = false;
};

const resetKey = ref(0);
</script>
<template>
  <CrowdfundingLiveOrganism
    :showmessage="showmessage"
    :showranking="showranking"
    :videourl="videourl"
    :videourlforondemand="videourlforondemand"
    :sendmessage="sendmessage"
    :addresses="addresses"
    :defaultAddress="defaultAddress"
    :defaultpaymentmethod="defaultpaymentmethod"
    :cardsInfo="cardsInfo"
    :rankingarray="rankingarray"
    :goodsData="goodsData"
    :orderId="orderId"
    :error="error"
    :errorfortreca="errorfortreca"
    :supercommentDone="supercommentDone"
    :defaultCard="defaultCard"
    :isLoadingforcredit="isLoadingforcredit"
    :shippingFee="shippingFee"
    :totallPrice="totallPrice"
    :sumPrice="sumPrice"
    :vendorsData="vendorsData"
    :suppercommenttype="suppercommenttype"
    :goods_dialogaftercarrier="goods_dialogaftercarrier"
    :goods_dialogaftercarrierfortreca="goods_dialogaftercarrierfortreca"
    :ochaPrice="ochaPrice"
    @shippingfeeandorderprice="shippingfeeandorderprice"
    @comfirmBuy="comfirmBuy"
    @comfirmBuyforcarrierpayment="comfirmBuyforcarrierpayment"
    @comfirmGoodsforcarrierpayment="comfirmGoodsforcarrierpayment"
    @chooseGoods="chooseGoods"
    @chooseTreca="chooseTreca"
    @comfirmGoods="comfirmGoods"
    @comfirmGoodsforpaidy="comfirmGoodsforpaidy"
    @sendaddress="sendaddress"
    :key="resetKey"
    ref="component"
    @commentinput="commentinput"
    @getAddressData="getAddressData"
    @getCreditCard="getCreditCard"
    @changecupercommentDone="changecupercommentDone"
    :user="user"
    :vendorname_ja="vendorname_ja"
    :campaignId="event_id"
    :currentAmount="currentAmount"
    :targetAmount="targetAmount"
    :MessageTime="MessageTime"
    :isArchive="true"
    @comfirmCrowdfundingSupport="comfirmCrowdfundingSupport"
  />
</template>

<style scoped>
.reset {
  width: 500px;
  height: 3000px;
}
</style>
